export default "__VITE_ASSET__ded3742e__"